module.exports = __webpack_public_path__ + "img/reactor-lights-color.602b987d.png";